import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const CustomersAndOrdersViewAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminEmbeddedCxAdminAppView],
  },
]

export const CustomerDetailViewAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminCustomersDetailsView],
  },
]

export const OrderDetailViewAccessControl: DomainAccessControlConfig = [
  {
    // TODO: Change to specific order details permission once it's added
    permissions: [Permission.CareAdminEmbeddedCxAdminAppView],
  },
]

// Create permission for all appeasement actions (delivery- and item-level), on top of the page view gate.
export const OrderAppeasementsAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminOrdersAppeasementsCreate],
  },
]

// Gates the order history tab on the customer detail page — shows the list of past orders.
export const CustomerOrderHistoryViewAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminCustomersOrdersView],
  },
]

// Gates the IPP customer search page. Users without this permission are redirected to the embedded legacy cx-admin search instead.
export const CustomerSearchViewAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminCustomersSearchView],
  },
]

// Gates the double-F keyboard shortcut that opens the fast-find search modal from anywhere in the portal.
export const CustomerSearchFastFindAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminCustomersSearchFastFind],
  },
]

// Gates the "recently visited" customers section shown on the search landing page.
export const CustomerSearchLatestAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminCustomersSearchLatest],
  },
]
